import React from "react";
import { Grid } from "@mui/material";
import AcxSelectSingle from "components/UI/Select/BaseSelectComponents/AcxSelectSingle";
import { Title } from "./SmallCard";
import { ExpandMore } from "@mui/icons-material";
import theme from "Theme/AppTheme";
import SmallCardStore, {
    AvailableOptionObjects,
    SmallCardState,
} from "./SmallCardStore";

const SmallCardSelectTitle = ({
    store,
    options,
}: {
    store: SmallCardStore;
    options: AvailableOptionObjects[];
}) => {
    const titleColor = theme.palette.gray[500];

    return (
        <Grid
            container
            columnSpacing={0.25}
            alignItems="center"
            wrap="nowrap"
            sx={{ minWidth: 0, maxHeight: "52px" }}
        >
            <Grid item xs zeroMinWidth>
                <Title sx={{ minWidth: 0 }}>{store.title}</Title>
            </Grid>
            <Grid
                item
                style={{
                    flexShrink: 0,
                    position: "relative",
                    paddingBottom: "4px",
                    marginLeft: "4px",
                }}
            >
                <AcxSelectSingle
                    id="signals-average-call-duration-select"
                    isDisabled={store.getTaskLoading("refresh")}
                    dropdownIndicator={<ExpandMore htmlColor={titleColor} />}
                    customStyle={{
                        valueContainer: (provided) => ({
                            ...provided,
                            height: "20px",
                            paddingInline: "0px",
                            display: "flex",
                            alignItems: "start",
                            overflow: "visible",
                            top: "-4px", // add space between input and border part 1/2
                        }),
                        indicatorsContainer: (provided) => ({
                            ...provided,
                            height: "16px",
                            width: "16px",
                            justifyContent: "center",
                        }),
                        container: (provided) => ({
                            ...provided,
                            border: "none",
                            borderBottom: "2px solid",
                            borderRadius: "0px",
                            margin: "0",
                            padding: "0px",
                            width: "164px",
                            height: "20px",
                            top: "6px", // add space between input and border part 2/2
                            color: titleColor,
                        }),
                        singleValue: (provided) => ({
                            ...provided,
                            // react-select positions the single value element absolutely.
                            // It uses a combination of transform with translateY(50%) and top (50%) css properties
                            // to get it into the right place. For this implementation of the select it was
                            // becoming unpredictable where the value would be positioned. Therefore I opted to make
                            // the value container a flex container and align items start then reset the transorm (Y pos)
                            // and top to 0% here. I have found this to be more reliable but can break during hot reload sometimes.
                            transform: "translateY(0%)",
                            top: "0%",
                            fontSize: theme.typography.h5.fontSize,
                            fontWeight: theme.typography.fontWeightBold,
                            color: titleColor,
                            margin: "0px",
                        }),
                    }}
                    options={options}
                    valueField="value"
                    labelField="display"
                    defaultValue={options.find((option) => {
                        const property = option.property || "";
                        return option.value === store.state?.[property];
                    })}
                    onChange={async (filter) => {
                        const property = filter.property || "";
                        if (filter.value === store.state?.[property]) return;
                        const updatedState = {
                            [property]: filter.value,
                        } as SmallCardState;
                        await store.refreshForStateChange(updatedState);
                    }}
                />
            </Grid>
        </Grid>
    );
};

export default SmallCardSelectTitle;
